import React from 'react';
import ISA315ItControlEffectivenessType from './ISA315ItControlEffectivenessType';
import ISA315ItControlTesting from './ISA315ItControlTesting';

const IISA315ItControlsItem = {
	itControlName: ({itControlName}) => {
		return <>{itControlName}</>;
	},
	itControlDesignEffectivenessType: ISA315ItControlEffectivenessType,
	itControlTesting: ISA315ItControlTesting
};

export default IISA315ItControlsItem;
